import React from 'react';
import './QuiSommesNous.css';
import Hero from '../Hero/Hero';
// L'importation de useNavigate a été supprimée car elle n'était pas utilisée.
// import { useNavigate } from 'react-router-dom'; 

import ae7Image from '../../assets/ae7.png';
import ae8Image from '../../assets/ae8.png';
import ae9Image from '../../assets/ae9.png';

const QuiSommesNous = ({ renderHero }) => {
  // La ligne 'const navigate = useNavigate();' a été supprimée.

  return (
    <div className="qs-containerr"  >
      {renderHero && <Hero />}

      <section className="intro-section">
        <h2 className="title">Qui Sommes-Nous</h2>
        <p>
          Le Forum Tunisien des Leaders Maghrébines (FTLM) est une association nationale indépendante régie par le décret numéro 88 du 24 septembre 2011. Le FTLM est créé à l’initiative de femmes expertes, autonomes et solidaires ayant l’ambition de contribuer activement au développement socio-économique de la Tunisie.
        </p>
        <p>
          Le FTLM s’oriente vers le Maghreb pour lequel une vision globale régionale est aujourd’hui indispensable. Il envisage également la création d’un cadre de réflexion intermaghrébin autour des programmes de développement visant l’implication de la femme dans la mise en place des stratégies économiques, sociales et culturelles à l’échelle maghrébine.
        </p>
      </section>

      <section className="team-section">
        <h3 className="sub-title">Notre Organisation</h3>
        <div className="team-grid">
          <div className="team-member">
            <img src={ae7Image} alt="Présidente" />
            <h4>Présidente</h4>
            <p>Mme Raoudha Ben Saber</p>
          </div>
          <div className="team-member">
            <img src={ae8Image} alt="Trésorière" />
            <h4>Trésorière</h4>
            <p>Mme Samia Ghorbel</p>
          </div>
          <div className="team-member">
            <img src={ae9Image} alt="Secrétaire Général" />
            <h4>Secrétaire Général</h4>
            <p>Mme Kaouther Raach</p>
          </div>
        </div>
      </section>

      <section className="advanced-cards-section">
        <h3 className="sub-title">NOS OBJECTIFS</h3>
        <div className="advanced-cards">
          <div className="advanced-card">
            <div className="icon-circle"><i className="fa-solid fa-chart-line"></i></div>
            <h4>PROMOUVOIR L'ENTREPRENEURIAT FÉMININ</h4>
          </div>
          <div className="advanced-card">
            <div className="icon-circle"><i className="fa-solid fa-users"></i></div>
            <h4>CRÉER UNE SYNERGIE ENTRE LES FEMMES ENTREPRENEURES MAGHRÉBINES </h4>
          </div>
          <div className="advanced-card">
            <div className="icon-circle"><i className="fa-solid fa-graduation-cap"></i></div>
            <h4>DÉVELOPPER LE SENS DE LA CITOYENNETÉ CHEZ LES JEUNES</h4>
          </div>
          <div className="advanced-card">
            <div className="icon-circle"><i className="fa-solid fa-comments"></i></div>
            <h4>ENCOURAGER LE DIALOGUE DES CULTURES ET DE L'APPARTENANCE</h4>
          </div>
        </div>
      </section>

      <section className="advanced-cards-section">
        <h3 className="sub-title">NOTRE DOMAINE D'ACTION</h3>
        <div className="advanced-cards">
          <div className="advanced-card">
            <div className="icon-circle"><i className="fa-solid fa-chart-line"></i></div>
            <h4>ENTREPRENEURIAT FÉMININ</h4>
          </div>
          <div className="advanced-card">
            <div className="icon-circle"><i className="fa-solid fa-handshake"></i></div>
            <h4>ECONOMIE-CRÉATION D'EMPLOIS</h4>
          </div>
          <div className="advanced-card">
            <div className="icon-circle"><i className="fa-solid fa-bolt"></i></div>
            <h4>ENERGIES RENOUVELABLES</h4>
          </div>
          <div className="advanced-card">
            <div className="icon-circle"><i className="fa-solid fa-futbol"></i></div>
            <h4>SPORT, ÉDUCATION, CULTURE</h4>
          </div>
        </div>
      </section>
    </div>
  );
};

export default QuiSommesNous;